import { getPrevalentSeasonDescription, SeasonDescription } from '../seasons/seasons';
import {
  parseUTCDate,
  formatUTCDate,
  ensureChronologicalOrder,
} from '../../utils/date-utils/date-utils';

export class Term {
  public id: string;
  public instanceId: string;

  public startDate: Date;
  public endDate: Date;

  public startDateString: string;
  public endDateString: string;

  public isOSU: boolean;
  public countryCode: string;
  public seasonDescription: SeasonDescription;
  public locale: string;

  constructor(data: Partial<Record<Exclude<keyof Term, 'id'>, any>>, locale: string) {
    Object.assign(this, data);

    this.startDate = parseUTCDate(data.startDate);
    this.endDate = parseUTCDate(data.endDate);

    [this.startDate, this.endDate] = ensureChronologicalOrder(this.startDate, this.endDate);

    this.locale = locale?.toLowerCase() === 'zh' ? 'zh-CN' : 'en-GB';

    this.startDateString = formatUTCDate(this.startDate, this.locale);
    this.endDateString = formatUTCDate(this.endDate, this.locale);

    this.id = `term-${this.startDate.getTime()}-${this.endDate.getTime()}`;

    this.seasonDescription = getPrevalentSeasonDescription(
      this.startDate,
      this.endDate,
      this.isOSU,
    );
  }
}
